export default __webpack_public_path__ + "static/media/arrow.c2b9295f.svg";